import * as types from "../../actions/ActionTypes";

const initialState = {
    loading: false,
    data: null,
    error: null,
};

const getStepOneReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_STEP_ONE_START:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case types.GET_STEP_ONE_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case types.GET_STEP_ONE_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default getStepOneReducer;
